export default "__VITE_ASSET__DMjsCAOM__"